import { useState } from "react";
import logo from "./intro-section-with-dropdown-navigation-main/images/logo.svg";
import openMenu from "./intro-section-with-dropdown-navigation-main/images/icon-menu.svg";
import closeMenu from "./intro-section-with-dropdown-navigation-main/images/icon-close-menu.svg";
import arrowUp from "./intro-section-with-dropdown-navigation-main/images/icon-arrow-up.svg";
import arrowDown from "./intro-section-with-dropdown-navigation-main/images/icon-arrow-down.svg";
import todoIcon from "./intro-section-with-dropdown-navigation-main/images/icon-todo.svg";
import calenderIcon from "./intro-section-with-dropdown-navigation-main/images/icon-calendar.svg";
import reminderIcon from "./intro-section-with-dropdown-navigation-main/images/icon-reminders.svg";
import planning from "./intro-section-with-dropdown-navigation-main/images/icon-planning.svg";



const Header = () => {
    const [open, setOpen] = useState(false);
    const [features, setFeatures] = useState(false);
    const [company, setcompany] = useState(false);

    const handleMenu = () => {
        setOpen(!open);
    }

    const handleFeatures = () => {
        setFeatures(!features);
    }

    const handleCompany = () => {
        setcompany(!company);
    }

    return ( 
        <header id="navigate" className="flex justify-between p-2 relative " >
            <div className="">
                <img className="my-auto lg:h-10 lg:w-52" src={logo} alt="logo" />
            </div>

            
            <nav className={`lg:flex lg:flex-row lg:w-full lg:items-center lg:justify-between lg:max-w-[70rem] ${open ? 'absolute bg-slate-100 min-h-screen w-72 left-24 top-0 md:left-[216px] md:w-80 lg:relative' : 'hidden'}`}>
                <ul className="pt-16 pl-8 lg:flex lg:flex-row lg:justify-between lg:items-center lg:relative lg:pt-0 lg:space-x-7">
                    <div>
                        <li onClick={handleFeatures} className="flex items-center cursor-pointer mb-3 font-bold lg:relative">
                            <p className="mr-1  opacity-50 hover:opacity-100">Features</p> {features ? (<img className="h-2" src={arrowUp} alt="arrowup" />) : (<img className="h-2" src={arrowDown} alt="arrowDown" />) }
                        </li>
                        
                        { features &&
                            <ul className="ml-6 cursor-pointer lg:absolute lg:bg-white lg:rounded-xl lg:px-4 lg:pt-4 lg:-left-12">
                                <li className="flex ">
                                <img className="h-4 mr-2 mb-4" src={todoIcon} alt="todo" /> <p>Todo List</p> 
                                </li>
                                <li className="flex">
                                    <img className="h-4 mr-2 mb-4" src={calenderIcon} alt="calender" /> <p>Calender</p>
                                </li>
                                <li className="flex">
                                    <img className="h-4 mr-2 mb-4" src={reminderIcon} alt="reminder" /><p>Reminders</p>
                                </li>
                                <li className="flex item">
                                    <img className="h-4  mr-2 mb-4" src={planning} alt="todo" /><p>Planning</p>
                                </li>
                            </ul>
                        }
                    </div>

                    <div className=""> 
                        <li onClick={handleCompany} className="flex items-center cursor-pointer mb-3 font-bold lg:relative">
                            <p className="mr-1  opacity-50 hover:opacity-100">Company</p> { company ? (<img className="h-2" src={arrowUp} alt="arrowup" />) : (<img className="h-2" src={arrowDown} alt="arrowDown" />) } 
                        </li>

                        { company &&
                            <ul className="ml-6 cursor-pointer lg:absolute lg:bg-white lg:rounded-xl lg:px-3 lg:py-1 lg:left-28">
                                <li className="mb-4">History</li>
                                <li className="mb-4">Our Team</li>
                                <li className="mb-4 lg:mb-1">Blog</li>
                            </ul>
                        }
                    </div>
                    
                    <li className="mb-3 font-bold opacity-50 cursor-pointer hover:opacity-100">Careers</li>
                    <li className="mb-3 font-bold opacity-50 cursor-pointer hover:opacity-100">About</li>
                </ul>

                <div className="flex justify-center items-center flex-col lg:ml-xl lg:hidden lg:flex-row lg:justify-end lg:w-full lg:space-x-4">
                    <div className="flex justify-right items-center ">
                        <button className="mt-3 mb-3 lg:mt-0 lg:w-10">Login</button>
                    </div>
                    
                    <div className="flex justify-right items-center">
                        <button className="border text-white bg-black border-black py-2 px-6 mx-auto rounded-lg hover:bg-white hover:text-black lg:px-3 lg:py-1">Register</button>
                    </div>
                    
                </div>

            </nav>
       
            <div id="buttons" className="hidden justify-center items-center flex-col lg:right-0 lg:ml-xl lg:flex lg:flex-row lg:justify-end lg:w-72 lg:space-x-4">
                <div className="flex justify-right items-center">
                    <button className="mt-3 mb-3 lg:mt-0 lg:w-10">Login</button>
                </div>
                <div className="flex justify-right mb-3">
                    <button className="border text-white bg-black border-black rounded-lg hover:bg-white hover:text-black lg:px-3 lg:py-2">Register</button>
                </div>
            </div>


            <div className="relative lg:hidden">
                {open ? <img onClick={handleMenu} src={closeMenu} alt="close-menu" /> : <img onClick={handleMenu} src={openMenu} alt="open-menu" /> }
            </div>

        </header>
     );
}
 
export default Header;